import { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'

export function confirmOrderService(reflinkUuid: string, verificationHeader: string) {
   let errMessage = ''
   return httpClient
      .post(
         `/client-carts/reflinks/${reflinkUuid}`,
         {},
         {
            headers: {
               'X-Reflink-Verification-Code': verificationHeader,
            },
         }
      )
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK confirmOrder service', errMessage, 'error')
         throw error
      })
}
